"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-use-before-define */
/* eslint-disable no-plusplus */
const three_1 = require("three");
const OBB_js_1 = require("three/examples/jsm/math/OBB.js");
// eslint-disable-next-line import/no-cycle
const types_1 = require("~/store/types");
// eslint-disable-next-line import/no-cycle
const _1 = require(".");
const consts_1 = require("../consts");
// eslint-disable-next-line import/no-cycle
const utils_1 = require("../utils");
// eslint-disable-next-line import/no-cycle
const utils_3d_1 = require("../utils/utils.3d");
// eslint-disable-next-line import/no-cycle
const Extrusion_model_3d_1 = __importDefault(require("../models/Extrusion.model.3d"));
// eslint-disable-next-line import/no-cycle
const Panel_model_3d_1 = __importDefault(require("../models/Panel.model.3d"));
// eslint-disable-next-line import/no-cycle
const AnchorDetection_3d_1 = require("./AnchorDetection.3d");
// eslint-disable-next-line import/no-cycle
const SlotCoverSnappingFactory_1 = __importDefault(require("./SlotCoverSnapping/SlotCoverSnappingFactory"));
const tempVector = new three_1.Vector3();
const tempVector2 = new three_1.Vector3();
const tempQuaternion = new three_1.Quaternion();
const tempQuaternion2 = new three_1.Quaternion();
const SNAPPING_POINT = 'snapping point';
class SnappingTool {
    get MOVE_STEP() {
        return this.viewer.isImperialMeasurementUsed ? consts_1.consts.DEFAULT_EXTRUDE_STEP : consts_1.consts.DEFAULT_EXTRUDE_STEP_SI;
    }
    constructor(viewer, mainTool, dragControls) {
        this.object = null;
        this.highlightedObject = null;
        this.neighborObject = null;
        this.isSnappedToNeighborsEnd = false;
        this.isComponentAlignByExtrusion = false;
        this.oldPos = new three_1.Vector3(0, 0, 0);
        this.wrongConnectionErrorType = null;
        this.wrongConnectionMessage = null;
        this.viewer = viewer;
        this.dragControls = dragControls;
        this.mainTool = mainTool;
    }
    setObject(newObject) {
        this.object = newObject;
        this.object.snapped = false;
    }
    clearObject() {
        this.object = null;
        this.neighborObject = null;
    }
    getObject() {
        return this.object;
    }
    /**
     * Moves the active preview to a candidate position when its existing placement remains valid.
     * Returns a validation message and restores the previous position when the candidate is invalid.
     */
    tryPositionObject(nextPosition) {
        if (!this.object) {
            return 'This distance can only be edited while placing an item.';
        }
        const previousPosition = this.object.position.clone();
        this.object.setPosition(nextPosition);
        const error = this.getPositionError();
        if (error) {
            this.object.setPosition(previousPosition);
            return error;
        }
        this.mainTool.highlightingTool.translateConnectionHighlight(nextPosition.clone().sub(previousPosition), this.object.uuid);
        this.object.oldCoord.copy(nextPosition);
        return undefined;
    }
    getPositionError() {
        this.wrongConnectionErrorType = null;
        this.wrongConnectionMessage = null;
        if ((0, utils_3d_1.isComponent)(this.object)) {
            if (!this.neighborObject || !(0, utils_3d_1.isExtrusion)(this.neighborObject)) {
                return 'This position does not result in a supported placement.';
            }
            if (!utils_1.ConnectionUtils.areComponentAndExtrusionCompatibleByTap(this.object, this.neighborObject)) {
                const message = utils_1.Utils.generateComponentAndExtrusionIncompatibilityMessage(this.object);
                this.wrongConnectionErrorType = 'error';
                this.wrongConnectionMessage = message;
                return message;
            }
            const snapData = utils_1.ConnectionUtils.getSnappingData(this.object, this.neighborObject);
            const mountIsCompatible = !snapData.mountToType ||
                utils_1.ConnectionUtils.checkMountToAndSeriesCompatibility(snapData.mountedObject, snapData.neighborObject, snapData.mountToType);
            if (!snapData.snapped || !mountIsCompatible) {
                return 'This position does not result in a supported placement.';
            }
        }
        const excludeIDs = new Set([this.object.uuid, ...this.object.getConnectionExcludeIDs()]);
        if ((0, utils_3d_1.isComponent)(this.object) && this.neighborObject) {
            excludeIDs.add(this.neighborObject.uuid);
        }
        const collision = this.viewer.collisionProcessor.testCollisions(this.object, utils_1.Utils.getOBB(this.object), {
            excludeIDs,
            firstFoundCollisionOnly: true,
        });
        return collision.result ? 'This position overlaps another item.' : undefined;
    }
    setIsObjectVertical() {
        if (this.object) {
            this.object.insertedVertically = utils_1.Utils.areVectorsCollinear(this.object.directionNormal, consts_1.consts.DP_UP_DIR);
            this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveZ;
        }
    }
    initObjectTransformation() {
        this.mainTool.selectionTool.unselectAll();
        this.hideHighlightedObject();
    }
    setObjectRotationToDefault() {
        this.dragControls.setPositionShift(null);
        this.object.setRotation(utils_1.Utils.identityQuaternion);
        this.object.isRotatedForSnapping = false;
    }
    detectClosestNeighborSide(translateToPlane = true) {
        const closestIntersections = [];
        if (this.object) {
            const objectBbox = utils_1.Utils.getAABBox(this.object);
            const objectBboxCenter = new three_1.Vector3();
            const objectBboxSize = new three_1.Vector3();
            objectBbox.getCenter(objectBboxCenter);
            objectBbox.getSize(objectBboxSize);
            const translateVector = new three_1.Vector3(0, 0, 0);
            if (translateToPlane) {
                translateVector.setZ(objectBboxSize.z / 2 - 0.5);
            }
            const castingPoint = objectBboxCenter.add(translateVector);
            Object.keys(consts_1.consts.DIRECTIONS_LIST).forEach((direction) => {
                this.viewer.getRaycaster().set(castingPoint, consts_1.consts.DIRECTIONS_LIST[direction]);
                const objectsToDetect = this.filterAddedObjectsOuterBoxes();
                const sideIntersections = this.viewer.getRaycaster().intersectObjects(objectsToDetect, true);
                if (sideIntersections[0]) {
                    closestIntersections.push({
                        direction,
                        intersection: sideIntersections[0],
                    });
                }
            });
            // eslint-disable-next-line no-unsafe-optional-chaining
            closestIntersections.sort((a, b) => (a === null || a === void 0 ? void 0 : a.intersection.distance) - (b === null || b === void 0 ? void 0 : b.intersection.distance));
            const closestNeighbor = closestIntersections[0];
            if ((closestNeighbor === null || closestNeighbor === void 0 ? void 0 : closestNeighbor.intersection) && (closestNeighbor === null || closestNeighbor === void 0 ? void 0 : closestNeighbor.intersection.distance) < 5) {
                this.lightClosestNeighbors(closestNeighbor.intersection.object.parent);
            }
            else {
                this.hideHighlightedObject();
            }
            return closestNeighbor;
        }
        return null;
    }
    getObjectSnappingPointCentered(object, direction) {
        const objectBboxCenter = utils_1.Utils.getAABBoxCenter(object);
        const objectBboxSize = utils_1.Utils.getAABBoxSize(object);
        const translateVector = new three_1.Vector3(0, 0, 0);
        switch (direction) {
            case 'X':
                translateVector.setX(objectBboxSize.x / 2);
                break;
            case '-X':
                translateVector.setX(-objectBboxSize.x / 2);
                break;
            case 'Y':
                translateVector.setY(objectBboxSize.y / 2);
                break;
            case '-Y':
                translateVector.setY(-objectBboxSize.y / 2);
                break;
            case 'Z':
                translateVector.setZ(objectBboxSize.z / 2);
                break;
            case '-Z':
                translateVector.setZ(-objectBboxSize.z / 2);
                break;
            default:
                break;
        }
        const snappingPoint = objectBboxCenter.add(translateVector);
        return snappingPoint;
    }
    snappingToNeighborsEnd(closestNeighbor, rotationDirection) {
        // getting the neighbor extrusion from its outer box name
        const detectedObject = this.filterAddedObjectsById(closestNeighbor.object.name.split('|')[1])[0];
        if (!detectedObject) {
            return undefined;
        }
        // checking if we're trying to snap to the neighbor extrusion end
        // by its customScalingAxis param
        let neighborScalingAxis;
        const normal = detectedObject.directionNormal;
        if ((0, utils_3d_1.areNotEqual)(normal.x, 0)) {
            neighborScalingAxis = 'X';
            detectedObject.customScalingAxis = 'X';
        }
        else if ((0, utils_3d_1.areNotEqual)(normal.y, 0)) {
            neighborScalingAxis = 'Y';
            detectedObject.customScalingAxis = 'Y';
        }
        else if ((0, utils_3d_1.areNotEqual)(normal.z, 0)) {
            neighborScalingAxis = 'Z';
            detectedObject.customScalingAxis = 'Z';
        }
        const directions = {
            X: rotationDirection.x,
            Y: rotationDirection.y,
            Z: rotationDirection.z,
        };
        this.isSnappedToNeighborsEnd = (0, utils_3d_1.areNotEqual)(directions[neighborScalingAxis], 0);
        return this.isSnappedToNeighborsEnd;
    }
    getRealSnappingPoint(closestNeighbor, rotationDirection, neighborFaceDirection, neighborIsVertical, snapToNeighborsEnd, customSnapping = false) {
        if (!this.object) {
            return undefined;
        }
        let realSnappingPoint;
        const detectedObject = this.filterAddedObjectsById(closestNeighbor.object.name.split('|')[1])[0];
        if (!detectedObject) {
            return undefined;
        }
        const neighborSnappingPointCenteredPosition = this.getObjectSnappingPointCentered(closestNeighbor.object, neighborFaceDirection);
        // calculating horizontal translation adjustment
        // to snap to the neighbor side vertical central line lowest point
        let hypotenuse = 0;
        let vCathetus = 0;
        hypotenuse = neighborSnappingPointCenteredPosition === null || neighborSnappingPointCenteredPosition === void 0 ? void 0 : neighborSnappingPointCenteredPosition.distanceTo(closestNeighbor.point);
        vCathetus = neighborSnappingPointCenteredPosition.z - closestNeighbor.point.z;
        const hCathetus = Math.sqrt(Math.pow(hypotenuse, 2) - Math.pow(vCathetus, 2));
        if ((0, utils_3d_1.areNotEqual)(rotationDirection.x, 0)) {
            this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveX;
            if (neighborIsVertical || snapToNeighborsEnd) {
                realSnappingPoint = new three_1.Vector3(closestNeighbor.point.x, closestNeighbor.point.y < neighborSnappingPointCenteredPosition.y
                    ? closestNeighbor.point.y + hCathetus
                    : closestNeighbor.point.y - hCathetus, closestNeighbor.point.z);
            }
            else if (!neighborIsVertical && !snapToNeighborsEnd && customSnapping) {
                realSnappingPoint = new three_1.Vector3(closestNeighbor.point.x, closestNeighbor.point.y, neighborSnappingPointCenteredPosition.z);
            }
            else {
                realSnappingPoint = new three_1.Vector3(closestNeighbor.point.x, closestNeighbor.point.y, closestNeighbor.point.z);
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(rotationDirection.y, 0)) {
            this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveY;
            if (neighborIsVertical || snapToNeighborsEnd) {
                realSnappingPoint = new three_1.Vector3(closestNeighbor.point.x < neighborSnappingPointCenteredPosition.x
                    ? closestNeighbor.point.x + hCathetus
                    : closestNeighbor.point.x - hCathetus, closestNeighbor.point.y, closestNeighbor.point.z);
            }
            else if (!neighborIsVertical && !snapToNeighborsEnd && customSnapping) {
                realSnappingPoint = new three_1.Vector3(closestNeighbor.point.x, closestNeighbor.point.y, neighborSnappingPointCenteredPosition.z);
            }
            else {
                realSnappingPoint = new three_1.Vector3(closestNeighbor.point.x, closestNeighbor.point.y, closestNeighbor.point.z);
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(rotationDirection.z, 0)) {
            this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveZ;
            if (neighborIsVertical || snapToNeighborsEnd) {
                realSnappingPoint = new three_1.Vector3(neighborSnappingPointCenteredPosition.x, neighborSnappingPointCenteredPosition.y, neighborSnappingPointCenteredPosition.z);
            }
            else if (!neighborIsVertical && !snapToNeighborsEnd && customSnapping) {
                const scalingAxis = detectedObject.customScalingAxis;
                realSnappingPoint = new three_1.Vector3(scalingAxis === consts_1.consts.POSITIVE_AXES.positiveY
                    ? neighborSnappingPointCenteredPosition.x
                    : closestNeighbor.point.x, scalingAxis === consts_1.consts.POSITIVE_AXES.positiveX
                    ? neighborSnappingPointCenteredPosition.y
                    : closestNeighbor.point.y, neighborSnappingPointCenteredPosition.z);
            }
            else {
                realSnappingPoint = new three_1.Vector3(closestNeighbor.point.x, closestNeighbor.point.y, closestNeighbor.point.z);
            }
        }
        return realSnappingPoint;
    }
    rotateObjectToFaceTarget(target, objectNormal, compensateRotationShift = true) {
        if (!this.object) {
            return;
        }
        this.object.notFlatWise = false;
        this.neighborObject = target;
        const neighborIsVertical = this.neighborObject.insertedVertically;
        const neighborIsNotFlatWise = this.neighborObject.notFlatWise;
        const rotationDirection = objectNormal.clone();
        rotationDirection.negate();
        const directionNormal = this.neighborObject.directionNormal.clone();
        let isComponentWithAxis = false;
        if (this.object.partDetails.itemType === 'Component' && this.object.isAxisPresent) {
            isComponentWithAxis = true;
        }
        if (this.neighborObject.partDetails.itemType === 'Extrusion' && isComponentWithAxis) {
            this.setObjectRotationToDefault();
            this.object.rotateAlignByExtrusionAxis(this.object.directionNormal, objectNormal, directionNormal, neighborIsVertical);
            this.isComponentAlignByExtrusion = true;
            this.object.isRotatedForSnapping = true;
        }
        else {
            this.object.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(consts_1.consts.DP_UP_DIR, objectNormal));
        }
        if (neighborIsNotFlatWise || ((0, utils_3d_1.areNotEqual)(rotationDirection.x, 0) && neighborIsVertical)) {
            this.object.notFlatWise = true;
        }
        if (compensateRotationShift) {
            this.compensateRotationShift();
        }
    }
    compensateRotationShift() {
        const bbox = utils_1.Utils.getAABBox(this.object);
        const bBoxSize = new three_1.Vector3();
        bbox.getSize(bBoxSize);
        const distance = bBoxSize.z / 2;
        this.object.translate(new three_1.Vector3(0, 0, -1).multiplyScalar(distance));
        this.dragControls.setPositionShift(distance);
    }
    clearDetectedNeighbor() {
        this.neighborObject = null;
    }
    moveObjectToTarget(moveDirection, neighborFaceDirection, hoveredPartDirection) {
        var _a;
        if (!this.object) {
            return;
        }
        this.oldPos.copy(this.object.position);
        this.mainTool.dragControls.enabled = false;
        let closestNeighborDirection = hoveredPartDirection;
        closestNeighborDirection !== null && closestNeighborDirection !== void 0 ? closestNeighborDirection : (closestNeighborDirection = this.detectClosestNeighborSide(false));
        // we will pass intersection under the mouse and hardcoded direction.
        const closestNeighbor = closestNeighborDirection === null || closestNeighborDirection === void 0 ? void 0 : closestNeighborDirection.intersection;
        if (!closestNeighbor || (this.object.snapped && !hoveredPartDirection.direction)) {
            return;
        }
        const detectedObject = this.filterAddedObjectsById(closestNeighbor === null || closestNeighbor === void 0 ? void 0 : closestNeighbor.object.name.split('|')[1])[0];
        if (!detectedObject) {
            return;
        }
        if (this.object.partDetails.itemType === 'Component') {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
            this.object.directionNormal.copy((_a = hoveredPartDirection === null || hoveredPartDirection === void 0 ? void 0 : hoveredPartDirection.intersection.face) === null || _a === void 0 ? void 0 : _a.normal);
        }
        this.neighborObject = detectedObject; // ?????????????????
        const neighborIsVertical = detectedObject === null || detectedObject === void 0 ? void 0 : detectedObject.insertedVertically;
        const rotationDirection = closestNeighbor.face.normal.clone();
        rotationDirection.negate();
        let realSnappingPoint;
        const snappingPointCenteredPosition = this.getObjectSnappingPointCentered(this.object, moveDirection);
        const snapToNeighborsEnd = this.snappingToNeighborsEnd(closestNeighbor, rotationDirection);
        if (snapToNeighborsEnd) {
            realSnappingPoint = this.getObjectSnappingPointCentered(detectedObject, neighborFaceDirection);
        }
        else {
            // calculating snapping points CENTERED positions
            realSnappingPoint = this.getRealSnappingPoint(closestNeighbor, rotationDirection, neighborFaceDirection, neighborIsVertical, snapToNeighborsEnd, true);
        }
        if (!realSnappingPoint) {
            return;
        }
        const directionForMove = realSnappingPoint.clone().sub(snappingPointCenteredPosition);
        directionForMove.normalize();
        // moving the model towards the previously calculated point on the neighbor`s face/end
        if (this.object.isRotatedForSnapping) {
            this.object.translate(directionForMove.multiplyScalar(snappingPointCenteredPosition.distanceTo(realSnappingPoint)));
        }
        // Enabling to drag the model on the neighbor`s surface
        let currentNeighborExists = false;
        this.dragControls.surfaceMeshes.forEach((el) => {
            if (el.name === closestNeighbor.object.name) {
                currentNeighborExists = true;
            }
        });
        if (currentNeighborExists === false) {
            this.dragControls.surfaceMeshes.push(closestNeighbor.object);
        }
        this.object.neighborFaceDirection = neighborFaceDirection;
        const axes = ['x', 'y', 'z'];
        axes.forEach((axis) => {
            if (!neighborFaceDirection.toLowerCase().includes(axis)) {
                const newPosition = this.object.position.clone();
                newPosition[axis] = Math.round(this.object.position.clone()[axis] / this.MOVE_STEP) * this.MOVE_STEP;
                this.object.setPosition(newPosition);
            }
        });
        this.mainTool.snapHelper.try2SnapObjByBoxCenter(this.object, rotationDirection.clone().negate());
    }
    /**
     * Updates the connections of the selected object.
     * This function is used to send connection updates to the backend
     * so that it can calculate the optimal number fasteners.
     *
     * @param obj the transform object. Can be either a Panel or an Extrusion
     */
    updateIntersectionRectangles(obj) {
        obj.connectedItems.forEach((connectedItem) => {
            const { uuid } = connectedItem;
            const conObj = this.viewer.getObjectById(uuid);
            if (conObj === undefined ||
                (!(conObj instanceof Panel_model_3d_1.default) && !(conObj instanceof Extrusion_model_3d_1.default)) ||
                (obj instanceof Panel_model_3d_1.default && conObj instanceof Panel_model_3d_1.default) ||
                (obj instanceof Extrusion_model_3d_1.default && conObj instanceof Extrusion_model_3d_1.default)) {
                return;
            }
            const panel = obj instanceof Panel_model_3d_1.default ? obj : conObj;
            const extrusion = conObj instanceof Extrusion_model_3d_1.default ? conObj : obj;
            const { width, length } = utils_1.Utils.intersectionRectangle(panel, extrusion);
            // eslint-disable-next-line no-param-reassign
            connectedItem.intersectionRectangle = { width, length };
            const idx = conObj.connectedItems.findIndex((item) => item.uuid === obj.uuid);
            if (idx !== -1) {
                conObj.connectedItems[idx].intersectionRectangle = {
                    width,
                    length,
                };
            }
        });
    }
    getStandardAxisRotationAngle(rotationAxis) {
        let rotationAngle = 0;
        if ((0, utils_3d_1.areNotEqual)(rotationAxis.x, 0)) {
            rotationAngle = rotationAxis.x > 0 ? Math.PI / 2 : -Math.PI / 2;
        }
        else if ((0, utils_3d_1.areNotEqual)(rotationAxis.y, 0)) {
            rotationAngle = rotationAxis.y < 0 ? Math.PI / 2 : -Math.PI / 2;
        }
        else if ((0, utils_3d_1.areNotEqual)(rotationAxis.z, 0)) {
            rotationAngle = rotationAxis.z < 0 ? Math.PI / 2 : -Math.PI / 2;
        }
        return rotationAngle;
    }
    getRotationAxisArray(direction, neighborIsVertical, neighborIsNotFlatWise, detectedObject) {
        if (!this.object) {
            return undefined;
        }
        const rotationAxisArray = [];
        if ((0, utils_3d_1.areNotEqual)(direction.x, 0)) {
            rotationAxisArray.push(new three_1.Vector3(0, 1, 0));
            if (!neighborIsVertical && !neighborIsNotFlatWise) {
                rotationAxisArray.push(new three_1.Vector3(0, 0, 1));
            }
            if (this.object) {
                this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveX;
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(direction.y, 0)) {
            rotationAxisArray.push(new three_1.Vector3(1, 0, 0));
            if (!neighborIsVertical && neighborIsNotFlatWise) {
                rotationAxisArray.push(new three_1.Vector3(0, 0, 1));
            }
            if (this.object) {
                this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveY;
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(direction.z, 0)) {
            if (neighborIsNotFlatWise) {
                if (detectedObject && (0, utils_3d_1.areNotEqual)(detectedObject.directionNormal.y, 0)) {
                    rotationAxisArray.push(new three_1.Vector3(0, 0, 1));
                }
            }
            else if (detectedObject && (0, utils_3d_1.areNotEqual)(detectedObject.directionNormal.x, 0)) {
                rotationAxisArray.push(new three_1.Vector3(0, 0, 1));
            }
            if (this.object) {
                this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveZ;
            }
        }
        return rotationAxisArray;
    }
    rotateObjectByAxis(rotationAxisArray, rotationAngle) {
        if (!this.object) {
            return;
        }
        for (let i = 0; i < rotationAxisArray.length; i += 1) {
            this.object.rotateOnAxis(rotationAxisArray[i], rotationAngle);
        }
        this.object.isRotatedForSnapping = true;
        if (this.object.partDetails.itemType !== 'Component') {
            this.object.setObjectDirectionNormal(utils_1.Utils.letter2Vec(this.mainTool.scalingDirection));
        }
        this.snappedRotation = new three_1.Euler().copy(this.object.rotation);
    }
    filterAddedObjectsOuterBoxes() {
        return this.viewer.getScene().children.reduce((outerBoxes, object) => {
            if (object instanceof _1.BaseObject3D) {
                outerBoxes.push(object.outerBox);
            }
            return outerBoxes;
        }, []);
    }
    filterAddedObjectsById(uuid) {
        return this.viewer.getScene().children.filter((child) => {
            return child.isCustomObject && child.uuid === uuid;
        });
    }
    hideHighlightedObject() {
        var _a;
        if (!this.highlightedObject) {
            return;
        }
        const neighborObjectId = (_a = this.highlightedObject) === null || _a === void 0 ? void 0 : _a.name.split('|')[1];
        const index = this.mainTool.selectionTool.selectedObjects.findIndex((obj) => obj.uuid === neighborObjectId);
        if (index < 0) {
            this.highlightedObject.visible = false;
            this.highlightedObject = null;
        }
    }
    lightClosestNeighbors(object) {
        this.viewer.getDesignProMain().highlightingTool.highlightObject(object, consts_1.consts.OUTER_BOX_COLOR);
    }
    isSomethingHighlighted() {
        return !!this.highlightedObject;
    }
    snapToAngledExtrusionBySnappingPoints(slotsData, intersectionPoint) {
        if (this.object.type !== types_1.ITEM_TYPE.COMPONENT) {
            return [false, []];
        }
        const nearestSlot = slotsData[0];
        if (!utils_1.Utils.isVectorAnAxis(nearestSlot.normal)) {
            return [false, []];
        }
        if (this.object.type === types_1.ITEM_TYPE.COMPONENT && this.object.hasSwappedMetadataPoints) {
            this.object.swapMetadataPoints();
        }
        const rotationToAlignWithSlotNormal = tempQuaternion2.setFromUnitVectors(consts_1.consts.DP_UP_DIR, nearestSlot.normal);
        // rotate to make component directionNormal equal to slot normal
        this.object.setRotation(rotationToAlignWithSlotNormal);
        // align with slot direction
        let alignmentAxis = this.object.getAlignmentAxis();
        if (alignmentAxis) {
            this.object.rotate(tempQuaternion.setFromUnitVectors(alignmentAxis, this.neighborObject.directionNormal));
        }
        const alongSlotLine = new three_1.Line3(nearestSlot.surfacePoint
            .clone()
            .add(tempVector.copy(nearestSlot.direction).multiplyScalar(nearestSlot.length / 2)), nearestSlot.surfacePoint
            .clone()
            .add(tempVector2.copy(nearestSlot.direction.clone().negate()).multiplyScalar(nearestSlot.length / 2)));
        let masterSnappingPointPosition = alongSlotLine.closestPointToPoint(intersectionPoint, false, new three_1.Vector3());
        const tempLength = masterSnappingPointPosition.distanceTo(alongSlotLine.start);
        masterSnappingPointPosition = alongSlotLine.start.clone().add(masterSnappingPointPosition
            .clone()
            .sub(alongSlotLine.start)
            .setLength(Math.round(tempLength / this.MOVE_STEP) * this.MOVE_STEP));
        const masterSnappingPoint = utils_1.Utils.getMasterSnappingPoints(this.object)[0];
        this.object.translate(tempVector.subVectors(masterSnappingPointPosition, masterSnappingPoint));
        const getRotationVariants = () => utils_1.Utils.getRotationVariants(this.object, this.neighborObject, {
            normal: nearestSlot.normal,
            up: nearestSlot.direction,
            right: nearestSlot.direction.clone().cross(nearestSlot.normal),
        }, masterSnappingPointPosition, this.viewer.collisionProcessor, this.viewer.getScene(), { numberOfRotations: 4, checkSlots: true, checkPanels: true, includeAngledExtrusions: true });
        let angledRotationVariants = [];
        if (this.object.getAlignmentAxis()) {
            angledRotationVariants = getRotationVariants();
            this.object.setRotation(rotationToAlignWithSlotNormal, masterSnappingPointPosition);
        }
        const alignedRotationVariants = getRotationVariants();
        const allRotationVariants = angledRotationVariants
            .map((v) => (Object.assign(Object.assign({}, v), { angled: true })))
            .concat(alignedRotationVariants.map((v) => (Object.assign(Object.assign({}, v), { angled: false }))));
        allRotationVariants.sort((a, b) => {
            if (!a.collision.any && b.collision.any) {
                return -1;
            }
            if (a.collision.any && !b.collision.any) {
                return 1;
            }
            if (a.snappingPointsFittedToPanels.length !== b.snappingPointsFittedToPanels.length) {
                return b.snappingPointsFittedToPanels.length - a.snappingPointsFittedToPanels.length;
            }
            if (a.numberOfSnappingPointsFittedToSlots !== b.numberOfSnappingPointsFittedToSlots) {
                return b.numberOfSnappingPointsFittedToSlots - a.numberOfSnappingPointsFittedToSlots;
            }
            if (utils_1.Utils.areNotEqual(a.alignDistance, b.alignDistance)) {
                return a.alignDistance - b.alignDistance;
            }
            if (a.angled !== b.angled) {
                return +b.angled - +a.angled;
            }
            if (a.slots.length !== b.slots.length) {
                return a.slots.length - b.slots.length;
            }
            return a.rotationAngle - b.rotationAngle;
        });
        if (!allRotationVariants[0].collision.any) {
            // TODO refactor code to save ready-to-use rotation instead of rotation angle and remove this "if"
            alignmentAxis = this.object.getAlignmentAxis();
            if (allRotationVariants[0].angled && alignmentAxis) {
                this.object.rotate(tempQuaternion.setFromUnitVectors(alignmentAxis, this.neighborObject.directionNormal));
            }
            this.object.rotate(tempQuaternion.setFromAxisAngle(nearestSlot.normal, allRotationVariants[0].rotationAngle), true, masterSnappingPointPosition);
            this.object.setPosition(allRotationVariants[0].alignedPosition);
            return [true, allRotationVariants[0].slots];
        }
        return [false, []];
    }
    snapBySnappingPoints(anchorTestResult) {
        this.mainTool.dragControls.enabled = false;
        if (!anchorTestResult.objectUUID) {
            return false;
        }
        this.neighborObject = this.viewer.getObjectById(anchorTestResult.objectUUID);
        if (!this.neighborObject) {
            return false;
        }
        this.object.snappedToAngledExtrusion = false;
        let snapped = false;
        let connectedObjectsData = new Map();
        if (anchorTestResult.resultType === AnchorDetection_3d_1.AnchorResultType.snapPt) {
            const { far, right } = utils_1.Utils.getRelatedToCameraDirections(this.viewer.getCamera(), anchorTestResult.resultData[0].origin, anchorTestResult.resultData[0].normal);
            [snapped, connectedObjectsData] = this.snapToSnappingPoint(anchorTestResult.resultData, right, far);
            if (snapped) {
                this.object.neighborFaceDirection = utils_1.Utils.vecToLetter(this.object.directionNormal);
            }
        }
        else if (this.neighborObject.type === 'Panel') {
            snapped = this.snapToPanel(anchorTestResult.intersectionPoint, anchorTestResult.intersectionNormal);
            if (snapped) {
                connectedObjectsData = new Map();
                connectedObjectsData.set('panel', [this.neighborObject.uuid]);
            }
        }
        else {
            [snapped, connectedObjectsData] = this.snapToSlot(anchorTestResult.resultData, anchorTestResult.intersectionPoint);
            if (snapped) {
                this.object.neighborFaceDirection = utils_1.Utils.vecToLetter(this.object.directionNormal);
            }
        }
        if (snapped) {
            this.object.snapped = true;
            this.snappedRotation = this.object.rotation.clone();
            this.updateConnectionValidation(connectedObjectsData !== null && connectedObjectsData !== void 0 ? connectedObjectsData : new Map());
        }
        this.isSnappedToNeighborsEnd = utils_1.Utils.areVectorsCollinear(this.object.directionNormal, this.neighborObject.directionNormal);
        return snapped;
    }
    updateConnectionValidation(connectedObjectsData) {
        var _a, _b;
        this.wrongConnectionErrorType = null;
        this.wrongConnectionMessage = null;
        if ((0, utils_3d_1.isExtrusion)(this.object) &&
            (0, utils_3d_1.isExtrusion)(this.neighborObject) &&
            this.viewer.props.drawingAngled &&
            !utils_1.Utils.areSeriesCompatible(this.object, this.neighborObject)) {
            this.mainTool.highlightingTool.highlightObject(this.object);
            this.mainTool.highlightingTool.highlightObject(this.neighborObject);
            this.wrongConnectionErrorType = 'error';
            this.wrongConnectionMessage = utils_1.Utils.getErrorMessageAboutSeriesMismatchOfAngledExtrusions((_a = this.viewer.props.allSeriesMap.get(this.object.partDetails.seriesIds[0])) !== null && _a !== void 0 ? _a : 'unknown series', (_b = this.viewer.props.allSeriesMap.get(this.neighborObject.partDetails.seriesIds[0])) !== null && _b !== void 0 ? _b : 'unknown series');
        }
        else if ((0, utils_3d_1.isExtrusion)(this.object) && (0, utils_3d_1.isComponent)(this.neighborObject)) {
            const extrusion = this.object;
            const component = this.neighborObject;
            const areSeriesCompatible = utils_1.Utils.areSeriesCompatible(extrusion, component);
            const componentMountTo = component.partDetails.mountTo;
            const canBeSnappedToExtrusion = componentMountTo.some((mountTo) => mountTo.type === 'Extrusion end' || mountTo.type === 'Extrusion slot');
            if (!areSeriesCompatible || !canBeSnappedToExtrusion) {
                this.wrongConnectionErrorType = 'error';
                this.wrongConnectionMessage = utils_1.Utils.generateMountToErrorMessage(component, [extrusion], this.viewer.props.seriesTypes);
                this.mainTool.highlightingTool.highlightObject(extrusion);
                this.mainTool.highlightingTool.highlightObject(component);
            }
            else if (!utils_1.ConnectionUtils.areComponentAndExtrusionCompatibleByTap(component, extrusion)) {
                this.wrongConnectionErrorType = 'error';
                this.wrongConnectionMessage = utils_1.Utils.generateComponentAndExtrusionIncompatibilityMessage(component);
                this.mainTool.highlightingTool.highlightObject(extrusion);
                this.mainTool.highlightingTool.highlightObject(component);
            }
        }
        else if ((0, utils_3d_1.isComponent)(this.object)) {
            let numberOfConnectedObjects = 0;
            const invalidConnectedObjects = [];
            const extrusionsWithInvalidConnection = [];
            connectedObjectsData.forEach((objectedUUIDs, snappingType) => {
                [...new Set(objectedUUIDs)]
                    .map((uuid) => {
                    const object = utils_1.Utils.getObjectByUUID(this.viewer.getScene(), uuid);
                    return { object, mountTo: utils_1.Utils.getMountToByTypeOfSnapping(snappingType, object) };
                })
                    .forEach(({ object, mountTo }) => {
                    if (mountTo && !utils_1.ConnectionUtils.checkMountToAndSeriesCompatibility(this.object, object, mountTo)) {
                        invalidConnectedObjects.push(object);
                    }
                    else if (snappingType === SNAPPING_POINT &&
                        utils_1.Utils.isExtrusion(object) &&
                        !utils_1.ConnectionUtils.areComponentAndExtrusionCompatibleByTap(this.object, object)) {
                        extrusionsWithInvalidConnection.push(object);
                    }
                    numberOfConnectedObjects++;
                });
            });
            if (invalidConnectedObjects.length === numberOfConnectedObjects && invalidConnectedObjects.length > 0) {
                this.wrongConnectionErrorType = 'error';
                this.wrongConnectionMessage = utils_1.Utils.generateMountToErrorMessage(this.object, invalidConnectedObjects, this.viewer.props.seriesTypes);
                this.mainTool.highlightingTool.highlightObject(this.object);
                invalidConnectedObjects.forEach((object) => this.mainTool.highlightingTool.highlightObject(object));
            }
            else if (extrusionsWithInvalidConnection.length &&
                extrusionsWithInvalidConnection.length === numberOfConnectedObjects) {
                this.wrongConnectionErrorType = 'error';
                this.wrongConnectionMessage = utils_1.Utils.generateComponentAndExtrusionIncompatibilityMessage(this.object);
                this.mainTool.highlightingTool.highlightObject(this.object);
                extrusionsWithInvalidConnection.forEach((object) => this.mainTool.highlightingTool.highlightObject(object));
            }
        }
    }
    snapToSnappingPoint(snappingPointsData, right, far) {
        var _a;
        if (utils_1.Utils.isCoverComponent(this.object)) {
            return [false, new Map()];
        }
        let snapped = false;
        let snappingPointsToHighlight = [];
        let slotsToHighlight = [];
        const connectedObjectsData = new Map();
        if (this.object.type === 'Extrusion') {
            if (utils_1.Utils.areEqual(0, this.object.additionalRotationAngle)) {
                snapped = this.snapExtrusionToSnappingPoint(snappingPointsData, right, far, false);
            }
            else {
                this.snapExtrusionToSnappingPoint(snappingPointsData, right, far, false);
                this.object.rotate(tempQuaternion.setFromAxisAngle(this.object.directionNormal, -this.object.additionalRotationAngle));
                snapped = this.snapExtrusionToSnappingPoint(snappingPointsData, right, far, true);
            }
            if (snapped) {
                connectedObjectsData.set(SNAPPING_POINT, [this.neighborObject.uuid]);
                snappingPointsToHighlight = utils_1.ConnectionUtils.findFittedSnappingPoints((_a = this.object.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], snappingPointsData, 'findSnappingPoints').points;
            }
        }
        else if (['Component', 'Panel'].includes(this.object.type)) {
            [snapped, snappingPointsToHighlight, slotsToHighlight] = this.snapComponentToSnappingPoint(snappingPointsData, right, far);
            connectedObjectsData.set(SNAPPING_POINT, snappingPointsToHighlight.map((point) => point.objectUUID));
            connectedObjectsData.set('slot', slotsToHighlight.map((slot) => slot.objectUUID));
        }
        if (snapped) {
            this.mainTool.highlightingTool.clearConnectionHighlight();
            this.mainTool.highlightingTool.highlightSnappingPoints(snappingPointsToHighlight);
            this.mainTool.highlightingTool.highlightSlots(slotsToHighlight, this.object.objectSnappedToTheCenter);
        }
        return [snapped, connectedObjectsData];
    }
    snapToSlot(slotsData, intersectionPoint) {
        var _a;
        const connectedObjectsUUIDs = new Map();
        let snapped = false;
        let slotsToHighlight = [];
        let collidedObjectUUIDs = [];
        if (utils_1.Utils.isCoverComponent(this.object)) {
            const slotCoverSnapping = SlotCoverSnappingFactory_1.default.getCoverSnapping(this.viewer, this.object);
            snapped = slotCoverSnapping.snapToSlot(slotsData[0], this.neighborObject, intersectionPoint);
            if (snapped) {
                slotsToHighlight = utils_1.ConnectionUtils.findSnappingToSlots(slotCoverSnapping.getSlotPoints(), slotsData, 'findSlots').slots;
                connectedObjectsUUIDs.set('slot', slotsToHighlight.map((slot) => slot.objectUUID));
            }
        }
        else if (utils_1.Utils.areNotEqual(this.neighborObject.scalingAngle, 0)) {
            [snapped, slotsToHighlight] = this.snapToAngledExtrusionBySnappingPoints(slotsData, intersectionPoint);
            if (snapped) {
                connectedObjectsUUIDs.set('slot', [...new Set(slotsToHighlight.map((slot) => slot.objectUUID))]);
                this.object.snappedToAngledExtrusion = true;
            }
        }
        else if (this.object.type === 'Extrusion') {
            if (utils_1.Utils.areEqual(this.object.additionalRotationAngle, 0)) {
                snapped = this.snapExtrusionToSlot(slotsData, intersectionPoint, false);
            }
            else {
                this.snapExtrusionToSlot(slotsData, intersectionPoint, false);
                this.object.rotate(tempQuaternion.setFromAxisAngle(this.object.directionNormal, -this.object.additionalRotationAngle));
                snapped = this.snapExtrusionToSlot(slotsData, intersectionPoint, true);
            }
            if (snapped) {
                slotsToHighlight = utils_1.ConnectionUtils.findSnappingToSlots((_a = this.object.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], slotsData, 'findSlots').slots;
                connectedObjectsUUIDs.set('slot', slotsToHighlight.map((slot) => slot.objectUUID));
            }
        }
        else if (['Component', 'Panel'].includes(this.object.type)) {
            let panels;
            [snapped, slotsToHighlight, panels, collidedObjectUUIDs] = this.snapComponentToSlot(slotsData, intersectionPoint);
            connectedObjectsUUIDs.set('slot', slotsToHighlight.map((slot) => slot.objectUUID));
            connectedObjectsUUIDs.set('panel', panels);
        }
        if (snapped) {
            this.mainTool.highlightingTool.clearConnectionHighlight();
            this.mainTool.highlightingTool.highlightSlots(slotsToHighlight, this.object.objectSnappedToTheCenter);
            if (collidedObjectUUIDs.length) {
                this.mainTool.highlightingTool.highlightObject(this.object);
                collidedObjectUUIDs.forEach((uuid) => {
                    const object = this.viewer.getObjectById(uuid);
                    if (object && (0, utils_3d_1.isBaseObject3D)(object)) {
                        this.mainTool.highlightingTool.highlightObject(object);
                    }
                });
            }
        }
        return [snapped, connectedObjectsUUIDs];
    }
    snapComponentToSlot(slotsData, intersectionPoint) {
        var _a, _b, _c, _d, _e, _f;
        const nearestSlot = slotsData[0];
        const right = nearestSlot.normal.clone().cross(nearestSlot.direction);
        if (this.object.partMetadata.alignmentAxis) {
            // rotate to have the same orientation as a slot
            this.object.setRotation(tempQuaternion.setFromUnitVectors(consts_1.consts.DP_UP_DIR, nearestSlot.normal));
            // rotate to always start search of optimal position from the same orientation along slot
            if (utils_1.Utils.areVectorsEqual(tempVector.copy(this.object.getAlignmentAxis()).negate(), nearestSlot.direction)) {
                this.object.rotate(tempQuaternion.setFromAxisAngle(nearestSlot.normal, Math.PI));
                // after this operation alignmentAxis is parallel to nearestSlot.direction
            }
            // rotating to place component along slot direction again?
            this.object.rotate(tempQuaternion.setFromUnitVectors(this.object.getAlignmentAxis(), nearestSlot.direction));
        }
        else {
            if (this.object.hasSwappedMetadataPoints) {
                this.object.swapMetadataPoints();
            }
            // rotate to have the same orientation as a slot
            this.object.setRotation(tempQuaternion.setFromUnitVectors(consts_1.consts.DP_UP_DIR, nearestSlot.normal));
        }
        const masterSnappingPointPosition = nearestSlot.surfacePoint
            .clone()
            .projectOnPlane(nearestSlot.direction)
            .add(tempVector2.copy(intersectionPoint).projectOnVector(nearestSlot.direction));
        this.object.setPosition(masterSnappingPointPosition);
        const translateToAlignAlongSlotVector = utils_1.Utils.alignObjectAlongSlot(utils_1.Utils.getAABBox(this.object), nearestSlot, this.MOVE_STEP);
        masterSnappingPointPosition.add(translateToAlignAlongSlotVector);
        const masterSnappingPointsCount = utils_1.Utils.getMasterSnappingPoints(this.object).length;
        const bbox = utils_1.Utils.getAABBox(this.object).expandByScalar(-consts_1.consts.COLLISION_PRECISION);
        const performFlip = ((_a = this.object.getInboundSnappingPointsRaw()) === null || _a === void 0 ? void 0 : _a.length) === ((_b = this.object.getRecommendedFastenerPointsRaw()) === null || _b === void 0 ? void 0 : _b.length) &&
            !!((_c = this.object.getRecommendedFastenerPointsRaw()) === null || _c === void 0 ? void 0 : _c.every((point) => !bbox.containsPoint(point))) &&
            utils_1.Utils.arePointsLayOnOnePlane(this.object.directionNormal, (_d = this.object.getInboundSnappingPointsRaw()) !== null && _d !== void 0 ? _d : []) &&
            utils_1.Utils.arePointsLayOnOnePlane(this.object.directionNormal, (_e = this.object.getRecommendedFastenerPointsRaw()) !== null && _e !== void 0 ? _e : []);
        const rotationSystem = { normal: nearestSlot.normal, up: nearestSlot.direction, right };
        const rotationOptions = {
            checkSlots: true,
            checkPanels: true,
            currentSlot: nearestSlot,
            includeAngledExtrusions: true,
            performFlip,
            moveStepToAlignAlongSlot: this.MOVE_STEP,
        };
        const rotationVariants = [];
        for (let idx = 0; idx < masterSnappingPointsCount; idx += 1) {
            const currentMasterSnappingPoint = utils_1.Utils.getMasterSnappingPoints(this.object)[idx];
            this.object.translate(tempVector.subVectors(masterSnappingPointPosition, currentMasterSnappingPoint));
            let numberOfRotations;
            if (this.object.type === 'Panel') {
                numberOfRotations = 1;
            }
            else if (this.object.partMetadata.alignmentAxis && this.object.testIntersection(this.neighborObject)) {
                // a part the extrusion passes through can only face two ways along it, never across
                // prevents incorrect rotations that cause collision
                numberOfRotations = 2;
            }
            else {
                numberOfRotations = 4;
            }
            rotationVariants.push(...utils_1.Utils.getRotationVariants(this.object, this.neighborObject, rotationSystem, masterSnappingPointPosition, this.viewer.collisionProcessor, this.viewer.getScene(), Object.assign({ numberOfRotations, flipMasterSnappingPointIndex: idx }, rotationOptions)));
        }
        rotationVariants.sort((a, b) => {
            if (!a.collision.any && b.collision.any) {
                return -1;
            }
            if (a.collision.any && !b.collision.any) {
                return 1;
            }
            if (a.snappingPointsFittedToPanels.length !== b.snappingPointsFittedToPanels.length) {
                return b.snappingPointsFittedToPanels.length - a.snappingPointsFittedToPanels.length;
            }
            if (a.numberOfSnappingPointsFittedToSlots !== b.numberOfSnappingPointsFittedToSlots) {
                return b.numberOfSnappingPointsFittedToSlots - a.numberOfSnappingPointsFittedToSlots;
            }
            if (a.flipped && !b.flipped) {
                return 1;
            }
            if (!a.flipped && b.flipped) {
                return -1;
            }
            if (utils_1.Utils.areNotEqual(a.alignDistance, b.alignDistance)) {
                return a.alignDistance - b.alignDistance;
            }
            return a.rotationAngle - b.rotationAngle;
        });
        if ((0, utils_3d_1.areNotEqual)(this.object.additionalRotationAngle, 0)) {
            const appliedVariant = this.applyAdditionalRotation(rotationVariants, masterSnappingPointPosition, rotationSystem);
            if (appliedVariant) {
                return [
                    true,
                    appliedVariant.slots,
                    [...appliedVariant.panelsUUIDs],
                    appliedVariant.collision.collidedObjectUUIDs,
                ];
            }
        }
        if (!rotationVariants[0].collision.any) {
            if (rotationVariants[0].flipped) {
                this.object.flipAroundMasterSnappingPoint(right, rotationVariants[0].flipMasterSnappingPointIndex);
            }
            utils_1.Utils.rotateObjectAroundPoint(this.object, masterSnappingPointPosition, tempQuaternion.setFromAxisAngle(nearestSlot.normal, rotationVariants[0].rotationAngle));
            this.object.setPosition(rotationVariants[0].alignedPosition);
            return [true, rotationVariants[0].slots, [...rotationVariants[0].panelsUUIDs], []];
        }
        if (this.object.partMetadata.alignmentAxis ||
            (rotationVariants.every((v) => v.collision.left) && rotationVariants.every((v) => v.collision.right))) {
            return [false, [], [], []];
        }
        const allRotationsBoundingBox = utils_1.Utils.getAllRotationBBox(utils_1.Utils.getAABBoxSize(this.object), nearestSlot.normal, masterSnappingPointPosition);
        const allRotationsBoundingBoxCollisionIndices = this.viewer.collisionProcessor.testCollisions(this.object, new OBB_js_1.OBB().fromBox3(allRotationsBoundingBox), {
            excludeIDs: new Set([this.object.uuid]),
        }).indices;
        const allCollidedSlots = allRotationsBoundingBoxCollisionIndices.flatMap((index) => this.viewer.collisionProcessor.getObjSlots(index));
        const allCollidedPanels = allRotationsBoundingBoxCollisionIndices
            .map((index) => utils_1.Utils.getObjectByUUID(this.viewer.getScene(), this.viewer.collisionProcessor.getObjUUID(index)))
            .filter((object) => object.type === types_1.ITEM_TYPE.PANEL);
        let result = false;
        if (rotationVariants.some((v) => v.collision.left && !v.collision.right)) {
            result = this.snapComponentToOneSlotWithRotationToSide(right, nearestSlot, masterSnappingPointPosition);
        }
        if (rotationVariants.some((v) => v.collision.right && !v.collision.left)) {
            result = this.snapComponentToOneSlotWithRotationToSide(right.clone().negate(), nearestSlot, masterSnappingPointPosition);
        }
        if (result) {
            return [
                true,
                utils_1.ConnectionUtils.findSnappingToSlots((_f = this.object.getInboundSnappingPointsRaw()) !== null && _f !== void 0 ? _f : [], allCollidedSlots, 'findSlots').slots,
                allCollidedPanels
                    .filter((panel) => utils_1.ConnectionUtils.areComponentAndPanelSnapped(this.object, panel))
                    .map((panel) => panel.uuid),
                [],
            ];
        }
        return [false, [], [], []];
    }
    snapComponentToSnappingPoint(snappingPoints, right, far) {
        const nearestPoint = snappingPoints[0];
        this.object.setRotation(tempQuaternion.setFromUnitVectors(consts_1.consts.DP_UP_DIR, nearestPoint.normal));
        // if (this.object.partMetadata.alignmentAxis) {
        //   this.object.rotate(tempQuaternion.setFromUnitVectors(this.object.getAlignmentAxis()!, far));
        // eslint-disable-next-line no-use-before-define
        if (this.object.partMetadata.alignmentAxis) {
            if (utils_1.Utils.areVectorsEqual(tempVector.copy(this.object.getAlignmentAxis()).negate(), far)) {
                this.object.rotate(tempQuaternion.setFromAxisAngle(nearestPoint.normal, Math.PI));
            }
            this.object.rotate(tempQuaternion.setFromUnitVectors(this.object.getAlignmentAxis(), far));
        }
        if (this.object.hasSwappedMetadataPoints) {
            this.object.swapMetadataPoints();
        }
        const masterSnappingPointsCount = utils_1.Utils.getMasterSnappingPoints(this.object).length;
        const rotationSystem = { normal: nearestPoint.normal, up: far, right };
        const rotationOptions = {
            numberOfRotations: 4,
            checkSnappingPoints: true,
            checkSlots: true,
        };
        const rotationVariants = [];
        for (let idx = 0; idx < masterSnappingPointsCount; idx += 1) {
            const currentMasterSnappingPoint = utils_1.Utils.getMasterSnappingPoints(this.object)[idx];
            this.object.translate(tempVector.subVectors(nearestPoint.origin, currentMasterSnappingPoint));
            rotationVariants.push(...utils_1.Utils.getRotationVariants(this.object, this.neighborObject, rotationSystem, nearestPoint.origin, this.viewer.collisionProcessor, this.viewer.getScene(), rotationOptions));
        }
        rotationVariants.sort((a, b) => {
            if (!a.collision.any && b.collision.any) {
                return -1;
            }
            if (a.collision.any && !b.collision.any) {
                return 1;
            }
            if (a.snappingPointsFittedToSnappingPoints.length !== b.snappingPointsFittedToSnappingPoints.length) {
                return b.snappingPointsFittedToSnappingPoints.length - a.snappingPointsFittedToSnappingPoints.length;
            }
            if (a.slots.length !== b.slots.length) {
                return b.slots.length - a.slots.length;
            }
            return a.rotationAngle - b.rotationAngle;
        });
        if ((0, utils_3d_1.areNotEqual)(this.object.additionalRotationAngle, 0)) {
            const appliedVariant = this.applyAdditionalRotation(rotationVariants, nearestPoint.origin, rotationSystem);
            if (appliedVariant) {
                return [true, appliedVariant.snappingPointsFittedToSnappingPoints, appliedVariant.slots];
            }
        }
        if (!rotationVariants[0].collision.any) {
            utils_1.Utils.rotateObjectAroundPoint(this.object, nearestPoint.origin, tempQuaternion.setFromAxisAngle(nearestPoint.normal, rotationVariants[0].rotationAngle));
            this.object.setPosition(rotationVariants[0].alignedPosition);
            return [true, rotationVariants[0].snappingPointsFittedToSnappingPoints, rotationVariants[0].slots];
        }
        return [false, [], []];
    }
    tryToSnapExtrusionsByWidth(snappingPointsOnSide, right, far, objectAlreadyRotated) {
        var _a, _b;
        const objectSize = utils_1.Utils.getAABBoxSize(this.object);
        const neighborObjectSize = utils_1.Utils.getAABBoxSize(this.neighborObject);
        let objectWidth = Math.abs(objectSize.dot(right));
        let objectLength = Math.abs(objectSize.dot(far));
        const neighborWidth = Math.abs(neighborObjectSize.dot(right));
        const neighborLength = Math.abs(neighborObjectSize.dot(far));
        // trying snap by width
        if (!objectAlreadyRotated &&
            !utils_1.Utils.isExtrusionSquare(this.object) &&
            utils_1.Utils.areEqual(objectWidth, neighborLength) &&
            utils_1.Utils.areEqual(objectLength, neighborWidth)) {
            tempQuaternion.setFromAxisAngle(this.object.directionNormal, consts_1.consts.HALF_PI);
            this.object.rotate(tempQuaternion);
        }
        else if (!objectAlreadyRotated &&
            (utils_1.Utils.areEqual(objectWidth, neighborLength) || utils_1.Utils.areEqual(objectLength, neighborWidth))) {
            const temp = objectWidth;
            objectWidth = objectLength;
            objectLength = temp;
            tempQuaternion.setFromAxisAngle(this.object.directionNormal, consts_1.consts.HALF_PI);
            this.object.rotate(tempQuaternion);
            if (utils_1.Utils.isExtrusionSquare(this.object)) {
                utils_1.Utils.alignExtrusionSlotsDuringSnappingToSnappingPoints(this.object, this.neighborObject);
            }
            const pointInNearestLeftCornerObject = utils_1.Utils.getPointOnMinCoord((_a = this.object.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], right, far);
            const pointInNearestLeftCornerNeighbor = utils_1.Utils.getPointOnMinCoord(snappingPointsOnSide, right, far);
            if (objectWidth > neighborWidth || utils_1.Utils.areEqual(objectWidth, neighborWidth)) {
                this.object.translate(pointInNearestLeftCornerNeighbor.clone().sub(pointInNearestLeftCornerObject).projectOnVector(right));
            }
            if (objectLength > neighborLength || utils_1.Utils.areEqual(objectLength, neighborLength)) {
                this.object.translate(pointInNearestLeftCornerNeighbor.clone().sub(pointInNearestLeftCornerObject).projectOnVector(far));
            }
            if (!this.viewer.collisionProcessor.testCollisions(this.object, utils_1.Utils.getOBB(this.object)).result &&
                utils_1.ConnectionUtils.findFittedSnappingPoints((_b = this.object.getInboundSnappingPointsRaw()) !== null && _b !== void 0 ? _b : [], snappingPointsOnSide, 'onlyCheckIfSnappingExists').snapped) {
                return true;
            }
        }
        return false;
    }
    snapExtrusionToSnappingPoint(snappingPointsData, right, far, objectAlreadyRotated = false) {
        var _a, _b;
        const nearestSnappingPoint = snappingPointsData[0];
        const snappingPointsOnSide = snappingPointsData.map((data) => data.origin);
        if (!objectAlreadyRotated) {
            this.object.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(consts_1.consts.DP_UP_DIR, nearestSnappingPoint.normal));
            if (utils_1.Utils.isExtrusionSquare(this.object) && (0, utils_3d_1.isExtrusion)(this.neighborObject)) {
                utils_1.Utils.alignExtrusionSlotsDuringSnappingToSnappingPoints(this.object, this.neighborObject);
            }
        }
        this.object.setPosition(nearestSnappingPoint.origin);
        if ((0, utils_3d_1.isExtrusion)(this.neighborObject)) {
            if (this.tryToSnapExtrusionsByWidth(snappingPointsOnSide, right, far, objectAlreadyRotated)) {
                return true;
            }
        }
        const pointInNearestLeftCorner = utils_1.Utils.getPointOnMinCoord(this.object.getInboundSnappingPointsRaw(), right, far);
        this.object.translate(nearestSnappingPoint.origin.clone().sub(pointInNearestLeftCorner).projectOnPlane(nearestSnappingPoint.normal));
        let { left: isCollidedFromLeft, right: isCollidedFromRight, up: isCollidedFromTop, bottom: isCollidedFromBottom, 
        // eslint-disable-next-line prefer-const
        any: isCollided, } = utils_1.Utils.getDirectionsOfCollision(far, right, this.object, new Set([this.neighborObject.uuid]));
        if (isCollidedFromBottom && isCollidedFromLeft && isCollidedFromRight && isCollidedFromTop) {
            return false;
        }
        if (!isCollided) {
            if (utils_1.ConnectionUtils.findFittedSnappingPoints((_a = this.object.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], snappingPointsOnSide, 'onlyCheckIfSnappingExists').snapped) {
                return true;
            }
            return false;
        }
        let temp1 = isCollidedFromLeft;
        let temp2 = isCollidedFromRight;
        // "!==" means xor in this context. Collision in corner detects in vertical and horizontal direction
        // , so if we have detection from left and right in the same time, it means we have collision on top or bottom
        isCollidedFromLeft && (isCollidedFromLeft = temp1 !== temp2);
        isCollidedFromRight && (isCollidedFromRight = temp1 !== temp2);
        temp1 = isCollidedFromTop;
        temp2 = isCollidedFromBottom;
        isCollidedFromTop && (isCollidedFromTop = temp1 !== temp2);
        isCollidedFromBottom && (isCollidedFromBottom = temp1 !== temp2);
        let directionForMove1;
        let directionForMove2;
        const unacceptableCollisionDirections = [];
        if (isCollidedFromLeft) {
            directionForMove1 = right;
            unacceptableCollisionDirections.push('right');
        }
        if (isCollidedFromRight) {
            directionForMove1 = right.clone().negate();
            unacceptableCollisionDirections.push('left');
        }
        if (isCollidedFromBottom) {
            directionForMove2 = far;
            unacceptableCollisionDirections.push('up');
        }
        if (isCollidedFromTop) {
            directionForMove2 = far.clone().negate();
            unacceptableCollisionDirections.push('bottom');
        }
        if (!directionForMove1 || !directionForMove2) {
            return false;
        }
        const neighborObjectSize = utils_1.Utils.getAABBoxSize(this.neighborObject);
        if (Math.abs(directionForMove2.dot(neighborObjectSize)) > Math.abs(directionForMove1.dot(neighborObjectSize))) {
            tempVector.copy(directionForMove1);
            directionForMove1.copy(directionForMove2);
            directionForMove2.copy(tempVector);
        }
        const initialObjectPosition = this.object.position.clone();
        // eslint-disable-next-line no-restricted-syntax
        for (const dir of [directionForMove1, directionForMove2]) {
            if (!dir) {
                break;
            }
            this.object.setPosition(initialObjectPosition);
            const negativeDirection = dir.clone().negate();
            // eslint-disable-next-line no-constant-condition
            while (true) {
                const pointToMove = utils_1.Utils.getNearestPointInDirection(this.object.getInboundSnappingPointsRaw(), negativeDirection, nearestSnappingPoint.origin);
                if (!pointToMove) {
                    break;
                }
                this.object.translate(dir.clone().multiplyScalar(pointToMove.delta));
                const collisionResult = utils_1.Utils.getDirectionsOfCollision(far, right, this.object);
                if (unacceptableCollisionDirections.some((collisionDirection) => collisionResult[collisionDirection])) {
                    break;
                }
                if (!collisionResult.any &&
                    utils_1.ConnectionUtils.findFittedSnappingPoints((_b = this.object.getInboundSnappingPointsRaw()) !== null && _b !== void 0 ? _b : [], snappingPointsOnSide, 'onlyCheckIfSnappingExists').snapped) {
                    return true;
                }
            }
        }
        return false;
    }
    snapExtrusionToSlot(slotsData, intersectionPoint, objectAlreadyRotated = false) {
        var _a, _b;
        const nearestSlot = slotsData[0];
        const right = nearestSlot.normal.clone().cross(nearestSlot.direction);
        const left = right.clone().negate();
        if (!objectAlreadyRotated) {
            this.object.setRotation(tempQuaternion.setFromUnitVectors(consts_1.consts.DP_UP_DIR, nearestSlot.normal));
            if (utils_1.Utils.isExtrusionSquare(this.object)) {
                utils_1.Utils.alignExtrusionSlotsDuringSnappingToSnappingPoints(this.object, this.neighborObject);
            }
        }
        const hoveredPointOnSlot = nearestSlot.surfacePoint
            .clone()
            .projectOnPlane(nearestSlot.direction)
            .add(intersectionPoint.clone().multiply(utils_1.Utils.absVector(nearestSlot.direction.clone())));
        this.object.setPosition(hoveredPointOnSlot);
        const translateToAlignAlongSlotVector = utils_1.Utils.alignObjectAlongSlot(utils_1.Utils.getAABBox(this.object), nearestSlot, this.MOVE_STEP);
        hoveredPointOnSlot.add(translateToAlignAlongSlotVector);
        const objectBboxSize = utils_1.Utils.getAABBoxSize(this.object);
        const objectWidth = Math.abs(right.dot(objectBboxSize));
        // trying to snap by width
        if (!objectAlreadyRotated) {
            const neighborBboxSize = utils_1.Utils.getAABBoxSize(this.neighborObject);
            const neighborWidth = Math.abs(right.dot(neighborBboxSize));
            const objSizes = objectBboxSize.clone().projectOnPlane(nearestSlot.normal).toArray([]);
            if (objSizes.some((sideSize) => utils_1.Utils.areEqual(neighborWidth, sideSize, consts_1.consts.EXTRUSION_SIZE_TOLERANCE))) {
                if (utils_1.Utils.areNotEqual(objectWidth, neighborWidth, consts_1.consts.EXTRUSION_SIZE_TOLERANCE)) {
                    this.object.rotate(new three_1.Quaternion().setFromAxisAngle(nearestSlot.normal, consts_1.consts.HALF_PI));
                }
                if (utils_1.Utils.isExtrusionSquare(this.object)) {
                    utils_1.Utils.alignExtrusionSlotsDuringSnappingToSlot(this.object, nearestSlot.direction);
                }
                this.object.setPosition(hoveredPointOnSlot);
                utils_1.Utils.clampObjectToNeighborBBox(this.object, this.neighborObject, nearestSlot.direction);
                utils_1.Utils.clampObjectToNeighborBBox(this.object, this.neighborObject, right, consts_1.consts.EXTRUSION_SIZE_TOLERANCE);
                this.viewer.getDesignProMain().snapHelper.snapObjectByBoundingBox(this.object, nearestSlot.direction);
                const isCollisionFound = this.viewer.collisionProcessor.testCollisions(this.object, utils_1.Utils.getOBB(this.object), {
                    excludeIDs: new Set([this.neighborObject.uuid]),
                    firstFoundCollisionOnly: true,
                }).result;
                if (utils_1.ConnectionUtils.findSnappingToSlots((_a = this.object.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], slotsData, 'onlyCheckIfSnappingExists').snapped &&
                    !isCollisionFound) {
                    return true;
                }
                return false;
            }
        }
        const objectLength = Math.abs(nearestSlot.direction.dot(objectBboxSize));
        if (objectWidth > objectLength && !objectAlreadyRotated) {
            this.object.rotate(new three_1.Quaternion().setFromAxisAngle(nearestSlot.normal, consts_1.consts.HALF_PI));
        }
        this.object.setPosition(hoveredPointOnSlot);
        const leftmostSnappingPoint = utils_1.Utils.getPointOnMinCoord(this.object.getInboundSnappingPointsRaw(), right);
        this.object.translate(tempVector.subVectors(nearestSlot.origin, leftmostSnappingPoint).projectOnVector(right));
        leftmostSnappingPoint.add(tempVector);
        utils_1.Utils.clampObjectToNeighborBBox(this.object, this.neighborObject, nearestSlot.direction);
        this.viewer.getDesignProMain().snapHelper.snapObjectByBoundingBox(this.object, nearestSlot.direction);
        const { left: isCollidedFromLeft, right: isCollidedFromRight } = utils_1.Utils.getDirectionsOfCollision(nearestSlot.direction, right, this.object, new Set([this.neighborObject.uuid]));
        if (isCollidedFromLeft) {
            return false;
        }
        if (isCollidedFromRight) {
            let currentSnappingPoint = leftmostSnappingPoint;
            // eslint-disable-next-line no-constant-condition
            while (true) {
                const nearestPoint = utils_1.Utils.getNearestPointInDirection(this.object.getInboundSnappingPointsRaw(), right, currentSnappingPoint);
                if (nearestPoint) {
                    this.object.translate(left.clone().multiplyScalar(nearestPoint.delta));
                    currentSnappingPoint = nearestPoint.point;
                    const collisionResult = utils_1.Utils.getDirectionsOfCollision(nearestSlot.direction, right, this.object);
                    if (!collisionResult.right) {
                        break;
                    }
                }
                else {
                    return false;
                }
            }
        }
        if (utils_1.ConnectionUtils.findSnappingToSlots((_b = this.object.getInboundSnappingPointsRaw()) !== null && _b !== void 0 ? _b : [], slotsData, 'onlyCheckIfSnappingExists').snapped) {
            return true;
        }
        return false;
    }
    snapToPanel(intersectionPoint, intersectionNormal) {
        var _a;
        if (((_a = this.object) === null || _a === void 0 ? void 0 : _a.type) !== 'Component' ||
            !utils_1.Utils.areVectorsCollinear(this.neighborObject.directionNormal, intersectionNormal) || // e.g. snapping to side face of panel
            this.neighborObject.isWireMesh()) {
            return false;
        }
        this.object.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(consts_1.consts.DP_UP_DIR, intersectionNormal));
        this.object.setPosition(intersectionPoint.clone().divideScalar(this.MOVE_STEP).round().multiplyScalar(this.MOVE_STEP));
        const directionsOfPanel = [
            consts_1.consts.DIRECTIONS_LIST[consts_1.consts.POSITIVE_AXES.positiveX],
            consts_1.consts.DIRECTIONS_LIST[consts_1.consts.POSITIVE_AXES.positiveY],
            consts_1.consts.DIRECTIONS_LIST[consts_1.consts.POSITIVE_AXES.positiveZ],
        ].filter((axis) => !utils_1.Utils.areVectorsCollinear(axis, intersectionNormal));
        if (this.object.partMetadata.alignmentAxis) {
            const neighborBboxSize = utils_1.Utils.getAABBoxSize(this.neighborObject);
            const longerSide = directionsOfPanel[0].dot(neighborBboxSize) > directionsOfPanel[1].dot(neighborBboxSize)
                ? directionsOfPanel[0]
                : directionsOfPanel[1];
            this.object.rotate(tempQuaternion.setFromUnitVectors(this.object.getAlignmentAxis(), longerSide));
        }
        utils_1.Utils.clampObjectToNeighborBBox(this.object, this.neighborObject, directionsOfPanel[0]);
        utils_1.Utils.clampObjectToNeighborBBox(this.object, this.neighborObject, directionsOfPanel[1]);
        if (this.viewer.collisionProcessor.testCollisions(this.object, utils_1.Utils.getOBB(this.object), {
            excludeIDs: new Set([this.neighborObject.uuid]),
        }).result ||
            !utils_1.Utils.isObjectCoveredByNeighbor(utils_1.Utils.getAABBox(this.object), utils_1.Utils.getAABBox(this.neighborObject), intersectionNormal)) {
            this.object.snapped = true;
        }
        return true;
    }
    getTempObjects() {
        let result = new Map();
        if (!this.object) {
            return result;
        }
        if (utils_1.Utils.isCoverComponent(this.object)) {
            const slotCoverSnapping = SlotCoverSnappingFactory_1.default.getCoverSnapping(this.viewer, this.object);
            result = slotCoverSnapping.getTempObjects();
        }
        return result;
    }
    removeTempSnappingChanges() {
        if (this.object.snapped === false) {
            return;
        }
        if (utils_1.Utils.isCoverComponent(this.object)) {
            const slotCoverSnapping = SlotCoverSnappingFactory_1.default.getCoverSnapping(this.viewer, this.object);
            slotCoverSnapping.restoreDefaultProps();
        }
    }
    static shouldNotBeCentered(object) {
        return 'shouldNotBeCentered' in object.userData && object.userData.shouldNotBeCentered;
    }
    snapComponentToOneSlotWithRotationToSide(side, nearestSlot, cursorNormilezedPosition) {
        const sideWithMaxSnappingPoints = utils_1.Utils.getSideWithMaxSnappingPoints(this.object.getInboundSnappingPointsRaw(), nearestSlot.normal);
        this.object.rotate(tempQuaternion.setFromUnitVectors(tempVector.copy(sideWithMaxSnappingPoints).negate(), side));
        const leftmostSnappingPoint = utils_1.Utils.getPointOnMinCoord(this.object.getInboundSnappingPointsRaw(), side);
        this.object.translate(tempVector.subVectors(cursorNormilezedPosition, leftmostSnappingPoint).projectOnVector(side));
        const collisionsBBox = new three_1.Box3();
        const collisions = utils_1.Utils.getDirectionsOfCollision(nearestSlot.direction, side, this.object, new Set([this.neighborObject.uuid]), collisionsBBox);
        if (collisions.up === collisions.bottom && collisions.any) {
            return false;
        }
        if (collisions.up || collisions.bottom) {
            this.object.translate(tempVector
                .copy(nearestSlot.direction)
                .multiplyScalar(collisions.bottom ? 1 : -1)
                .multiply(collisionsBBox.getSize(tempVector2)));
        }
        utils_1.Utils.clampObjectToNeighborBBox(this.object, this.neighborObject, nearestSlot.direction);
        const collided = this.viewer.collisionProcessor.testCollisions(this.object, utils_1.Utils.getOBB(this.object), {
            excludeIDs: new Set([this.neighborObject.uuid]),
        }).result;
        if (!collided) {
            return true;
        }
        return false;
    }
    // assume that rotation variants are sorted when taking best rotation variant
    applyAdditionalRotation(rotationVariants, masterSnappingPointPosition, coordinateSystem) {
        const bestRotationVariant = rotationVariants[0];
        // One entry per distinct angle, best first, so a press can never land on a visually identical pose
        const cycle = [];
        rotationVariants.forEach((variant) => {
            const isSameFlip = variant.flipped === bestRotationVariant.flipped;
            const isAngleTaken = cycle.some((picked) => (0, utils_3d_1.areEqual)(picked.rotationAngle, variant.rotationAngle));
            if (isSameFlip && !isAngleTaken) {
                cycle.push(variant);
            }
        });
        cycle.sort((a, b) => a.rotationAngle - b.rotationAngle);
        const bestIndex = cycle.findIndex((variant) => (0, utils_3d_1.areEqual)(variant.rotationAngle, bestRotationVariant.rotationAngle));
        // Space accumulates a quarter turn per press, but the cycle length decides what a press actually reaches
        const steps = Math.round(this.object.additionalRotationAngle / (Math.PI / 2));
        const targetRotationVariant = bestIndex === -1 ? undefined : cycle[(bestIndex + steps) % cycle.length];
        if (targetRotationVariant) {
            if (targetRotationVariant.flipped) {
                this.object.flipAroundMasterSnappingPoint(coordinateSystem.right, targetRotationVariant.flipMasterSnappingPointIndex);
            }
            utils_1.Utils.rotateObjectAroundPoint(this.object, masterSnappingPointPosition, tempQuaternion.setFromAxisAngle(coordinateSystem.normal, targetRotationVariant.rotationAngle));
            this.object.setPosition(targetRotationVariant.alignedPosition);
            return targetRotationVariant;
        }
        return null;
    }
}
exports.default = SnappingTool;
